"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainingTable = void 0;
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const messages_1 = __importDefault(require("../../../common/util/constants/messages"));
const styles_1 = require("../styles");
const getInstitutionContent = (training) => {
    const { name, city, state, country } = training;
    return [name, city, state, country].filter(Boolean).join(', ');
};
exports.TrainingTable = (0, intl_1.injectIntl)(({ id, labels: { tableHeaderLabels: { degreeHeaderLabel = 'Degree', fieldOfStudyHeaderLabel = 'Field of Study', yearHeaderLabel = 'Year', institutionHeaderLabel = 'Institution', descriptionHeaderLabel = 'Description' } = {}, nextPageLabel, previousPageLabel, noRecordsLabel, noRecordsOnSearchLabel }, intl, training, customColumns, stateEventHandlers }) => {
    const sortProps = react_1.default.useMemo(() => ({
        sortBy: [{ id: 'year', desc: true }]
    }), []);
    const paginatorProps = react_1.default.useMemo(() => ({
        pageSize: 10,
        currentPage: 0,
        nextPageRenderer: () => nextPageLabel,
        previousPageRenderer: () => previousPageLabel,
        totalCount: training.length,
        showOutOf: true
    }), [training.length, nextPageLabel, previousPageLabel]);
    const defaultColumns = react_1.default.useMemo(() => [
        {
            id: 'year',
            accessor: 'graduation_year',
            Header: yearHeaderLabel
        },
        {
            id: 'institution',
            accessor: (row) => {
                return getInstitutionContent(row);
            },
            Header: institutionHeaderLabel,
            Cell: ({ row }) => {
                return getInstitutionContent(row.original);
            }
        },
        {
            id: 'description',
            accessor: 'type',
            Header: descriptionHeaderLabel
        },
        {
            id: 'field-of-study',
            accessor: 'field_of_study',
            Header: fieldOfStudyHeaderLabel
        },
        {
            id: 'degree',
            accessor: 'degree',
            Header: degreeHeaderLabel
        }
    ], [
        degreeHeaderLabel,
        descriptionHeaderLabel,
        fieldOfStudyHeaderLabel,
        institutionHeaderLabel,
        yearHeaderLabel
    ]);
    const columns = react_1.default.useMemo(() => {
        if (customColumns == null)
            return defaultColumns;
        return customColumns(defaultColumns);
    }, [customColumns, defaultColumns]);
    return (react_1.default.createElement(styles_1.Table, { striped: true, id: id, columns: columns, data: training, sortProps: sortProps, paginatorProps: paginatorProps, noResultsMessage: (isFiltered) => isFiltered ? noRecordsOnSearchLabel : noRecordsLabel, stateEventHandlers: stateEventHandlers, ariaProps: {
            ariaLiveLabel: (count) => intl.formatMessage(messages_1.default.ariaLiveSearchResultCount, {
                count
            })
        } }));
});
//# sourceMappingURL=TrainingTable.js.map